import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

const shopLinks = [
  { name: 'All Collections', href: '/collections' },
  { name: 'Jeans', href: '/category/jeans' },
  { name: 'Shoes', href: '/category/shoes' },
  { name: 'Sale', href: '/sale' },
];

const companyLinks = [
  { name: 'About Us', href: '/about' },
  { name: 'Contact', href: '/contact' },
  { name: 'Shipping & Returns', href: '/contact' },
  { name: 'Size Guide', href: '/contact' },
];

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.includes('@')) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 4000);
    }
  };

  return (
    <footer className="bg-offblack text-offwhite">
      {/* Newsletter Section */}
      <div className="section-wide py-section border-b border-white/10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="font-display text-display-sm text-offwhite mb-3">
              Join armé
            </h3>
            <p className="font-sans text-sm text-warmgray-400 max-w-md">
              First access to new drops, exclusive offers, and stories from the world of armé.
            </p>
          </div>
          <form onSubmit={handleSubscribe} className="flex gap-0 max-w-md lg:ml-auto">
            <label htmlFor="footer-email" className="sr-only">Email address</label>
            <input
              id="footer-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              required
              className="flex-1 px-4 py-3.5 bg-white/5 border border-white/15 text-offwhite text-sm font-sans placeholder:text-warmgray-500 focus:outline-none focus:border-white/40 transition-colors"
            />
            <button
              type="submit"
              className="px-6 py-3.5 bg-offwhite text-offblack text-xs font-medium uppercase tracking-[0.1em] hover:bg-sand transition-colors"
            >
              {subscribed ? 'Subscribed ✓' : 'Subscribe'}
            </button>
          </form>
        </div>
      </div>

      {/* Main Footer */}
      <div className="section-wide py-section">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-5 space-y-6">
            <Link to="/" aria-label="armé — Home">
              <span className="font-display font-bold text-3xl tracking-[0.04em] text-offwhite">
                ARMÉ.
              </span>
            </Link>
            <p className="font-sans text-sm text-warmgray-400 leading-relaxed max-w-sm">
              Crafted for those who move with purpose. Premium jeans and shoes 
              delivered nationwide across Algeria.
            </p>

            {/* Social */}
            <div className="flex items-center gap-5 pt-2">
              <a
                href="https://instagram.com/arme__officiel/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-warmgray-500 hover:text-offwhite transition-colors text-xs uppercase tracking-[0.12em]"
                aria-label="Follow armé on Instagram"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" />
                </svg>
                Instagram
              </a>
            </div>
          </div>

          {/* Shop Links */}
          <div className="lg:col-span-3">
            <h4 className="text-xs font-sans font-medium uppercase tracking-[0.12em] text-warmgray-400 mb-5">
              Shop
            </h4>
            <ul className="space-y-3.5">
              {shopLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="font-sans text-sm text-warmgray-300 hover:text-offwhite transition-colors flex items-center group"
                  >
                    {link.name}
                    <ArrowRightIcon className="h-3 w-3 ml-1 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div className="lg:col-span-2">
            <h4 className="text-xs font-sans font-medium uppercase tracking-[0.12em] text-warmgray-400 mb-5">
              Company
            </h4>
            <ul className="space-y-3.5">
              {companyLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="font-sans text-sm text-warmgray-300 hover:text-offwhite transition-colors flex items-center group"
                  >
                    {link.name}
                    <ArrowRightIcon className="h-3 w-3 ml-1 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-2">
            <h4 className="text-xs font-sans font-medium uppercase tracking-[0.12em] text-warmgray-400 mb-5">
              Contact
            </h4>
            <div className="space-y-3 font-sans text-sm text-warmgray-300">
              <a href="tel:+21354906042" className="block hover:text-offwhite transition-colors">
                +213 549 06 04 22
              </a>
              <a href="mailto:contact@arme.dz" className="block hover:text-offwhite transition-colors">
                contact@arme.dz
              </a>
              <p>Algiers, Algeria</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="section-wide py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-warmgray-500 font-sans">
            © {new Date().getFullYear()} armé. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-warmgray-600">Payment:</span>
            <div className="flex gap-2">
              <span className="px-2 py-1 text-[0.6rem] border border-white/10 rounded text-warmgray-400">CIB</span>
              <span className="px-2 py-1 text-[0.6rem] border border-white/10 rounded text-warmgray-400">EDAHABIA</span>
              <span className="px-2 py-1 text-[0.6rem] border border-white/10 rounded text-warmgray-400">CASH</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
